<div class="col-span-12 lg:col-span-6 xl:col-span-4">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Total sucursales asignadas</span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{ branchesTotal }}</div>
            </div>
            <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-warehouse text-blue-500 !text-xl"></i>
            </div>
        </div>
    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-4">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Cierres Pendientes de Hoy</span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
                    {{ todayTotal }}
                </div>
            </div>
            <div class="flex items-center justify-center bg-orange-100 dark:bg-orange-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-chart-bar text-orange-500 !text-xl"></i>
            </div>
        </div>
    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-4">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Cierres Pendientes de Días Anteriores</span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
                    {{ previousTotal }}
                </div>
            </div>
            <div class="flex items-center justify-center bg-cyan-100 dark:bg-cyan-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-chart-bar text-cyan-500 !text-xl"></i>
            </div>
        </div>
    </div>
</div>
